/**
 * Level 14: Aurora Borealis
 * 
 * Mystical northern lights themed level:
 * - Beautiful aurora color scheme
 * - Ice platforms with low friction
 * - Wind zones simulating cold gusts
 * - Ethereal atmosphere
 * 
 * @module configs/levels/Level14_AuroraBorealis
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level14_AuroraBorealis = {
    id: 14,
    name: 'Aurora Borealis',
    subtitle: 'Northern Lights',
    description: 'Dance through the mystical northern lights.',
    
    worldWidth: 4600,
    worldHeight: 1700,
    playerStart: { x: 130, y: 1400 },
    gravity: 0.85,
    
    theme: {
        bgGradient: ['#0a1628', '#1a0a30'],  // Deep night sky
        platformColor: 0x88ccee,  // Ice blue
        accentColor: 0x00ff88,   // Aurora green
        particleColor: 0xff00ff   // Aurora purple
    },
    
    platforms: [
        // Frozen tundra start
        { x: 0, y: 1500, w: 380, h: 50 },
        { x: 450, y: 1350, w: 170, h: 22 },
        { x: 720, y: 1200, w: 180, h: 22 },
        
        // Ice cliffs
        { x: 1000, y: 1400, w: 280, h: 40 },
        { x: 1250, y: 1200, w: 160, h: 22 },
        { x: 1500, y: 1000, w: 190, h: 25 },
        
        // Aurora viewing platform
        { x: 1800, y: 1150, w: 350, h: 45 },
        { x: 2150, y: 950, w: 200, h: 25 },
        { x: 2450, y: 750, w: 180, h: 22 },
        
        // Crystal ice bridge
        { x: 2750, y: 900, w: 280, h: 35 },
        { x: 3050, y: 750, w: 170, h: 22 },
        { x: 3300, y: 600, w: 200, h: 25 },
        
        // Summit
        { x: 3600, y: 800, w: 300, h: 40 },
        { x: 3900, y: 650, w: 200, h: 25 },
        { x: 4200, y: 850, w: 400, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 600, y: 1280, w: 110, h: 20, moveY: 140, speed: 0.002 },
        { x: 1400, y: 1100, w: 120, h: 20, moveX: 130, speed: 0.0025 },
        { x: 2300, y: 850, w: 130, h: 20, moveY: 160, speed: 0.002 },
        { x: 3450, y: 700, w: 120, h: 20, moveX: 150, speed: 0.003 }
    ],
    
    // Ice spikes
    spikes: [
        { x: 1050, y: 1400 },
        { x: 1100, y: 1400 },
        { x: 1850, y: 1150 },
        { x: 2800, y: 900 },
        { x: 2850, y: 900 }
    ],
    
    stars: [
        { x: 720, y: 1100 },
        { x: 1500, y: 900 },
        { x: 2450, y: 650 },
        { x: 3300, y: 500 },
        { x: 3900, y: 550 }
    ],
    
    enemies: [
        { x: 1150, y: 1350 },
        { x: 1950, y: 1100 },
        { x: 2900, y: 850 },
        { x: 3700, y: 750 }
    ],
    
    door: { x: 4450, y: 700, w: 50, h: 300 },
    button: { x: 4300, y: 845 },
    box: { x: 3650, y: 700, floating: true },  // Floating ice crystal
    goal: { x: 4500, y: 750 },

    decorations: [
        { key: 'decor-aurora', centerInLevel: true, scale: 12, alpha: 0.35, scrollFactor: 0.12, depth: -50 }
    ],
    
    // Cold wind gusts
    windZones: [
        { x: 1700, y: 800, w: 400, h: 500, forceX: 2, forceY: 0 },
        { x: 2700, y: 500, w: 350, h: 500, forceX: -1.5, forceY: -0.5 },
        { x: 3800, y: 400, w: 400, h: 600, forceX: 0, forceY: -1 }  // Updraft
    ],
    
    trampolines: [
        { x: 900, y: 1400, w: 80 },
        { x: 2700, y: 900, w: 80 }
    ],
    
    speedrunTargets: { gold: 55, silver: 75, bronze: 100 }
};

export default Level14_AuroraBorealis;
